import { LicenseState } from '@/enums/licenseState';
import { CompleteLicense } from '@/interfaces/dashboard/licenses';
import { CommonService } from '@/services/common/common.service';
import { DashboardService, User } from '@/services/dashboard/dashboard.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { Component, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import SwiperCore, { A11y, Autoplay, Controller, Navigation, Pagination, Scrollbar, Thumbs, Virtual, Zoom } from 'swiper/core';

SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,
]);
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {

  @Output() userData: Partial<User> = {};
  @Output() licenseData: CompleteLicense[] = [];
  @Input() inputRut: string = '';
  @Output() licenseExpired: boolean = false;
  @Output() licenseSanctioned: boolean = false;
  @Output() requirementsList: Array<any> = [];

  licensesLoading: boolean = true;
  zonesRows: Array<number[]> = [];
  getLicensesError: string = 'DEFAULT';
  gettedPersonData: boolean = false;

  constructor(
    private dashboardService: DashboardService,
    private commonService: CommonService,
    private rutaActiva: ActivatedRoute,
    private store: Store<StoreState>,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (newState) => {
        this.userData = newState;
        this.gettedPersonData = true;
        this.getLicensesData(newState.mdmid);
        this.getRecentRequirements(newState.mdmid);
      },
    });
  }

  get showBannerVerification() {
    return this.licenseData.length > 0;
  }

  userEmail: string = '';

  ngOnInit(): void {
    this.userEmail = this.rutaActiva.snapshot.params.email;
  }

  getLicensesData(userId: string) {
    this.commonService.getLicenseByUser(userId)
      .subscribe({
        next: (data) => {
          this.licenseData = data.sort((a, b) => {
            if (a.asset.name > b.asset.name) {
              return 1;
            }
            if (a.asset.name < b.asset.name) {
              return -1;
            }
            return 0;
          });

          this.getZonesRows();
          this.stateValidation();
          this.licensesLoading = false;
        },
        error: () => {
          this.licenseData = [];
          this.getLicensesError = 'Ha ocurrido un error al intentar obtener la información asociada a licencias.';
          this.licensesLoading = false;
        },
      });
  }

  getZonesRows() {
    this.licenseData.forEach((license) => {
      const zonesRowsByAsset: number[] = [];
      license.equipments.forEach((vehicle) => {
        const zonesLength = vehicle.conductionZones.length;
        zonesRowsByAsset.push(Math.ceil(zonesLength / 2));
      });
      this.zonesRows.push(zonesRowsByAsset);
    });
  }

  getRecentRequirements(rut: string) {
    this.dashboardService.getRecentRequirements(rut)
      .subscribe((activities) => {
        this.requirementsList = <any>activities;
      });
  }

  getPdfLicense(licenseId: number) {
    this.dashboardService.getPdfLicense(licenseId)
      .subscribe((res) => res);
  }

  stateValidation() {
    this.licenseData.forEach((license) => {
      license.equipments.forEach((vehicle: any) => {
        if (vehicle.state !== LicenseState.VIGENTE || vehicle.state !== LicenseState.PROXIMO_A_VENCER || vehicle.state !== LicenseState.SUSPENDIDA) {
          this.licenseExpired = true;
        }
        // Para suspensi ón sanctionType viene en null e infringementId en 0
        if (license.sanction && license.sanction.sanctionType && license.sanction.infringementId !== 0 && license.sanction.sanctionType.trim().toUpperCase() !== 'SUSPENSIÓN') {

          this.licenseSanctioned = true;
        }
      });
    });
  }

  // container  tab request and activities
  tabState: boolean = false;
  openFirstTab() {
    this.tabState = false;
  }

  openSecondTab() {
    this.tabState = true;
  }

  controlledSwiper: any;
  setControlledSwiper(swiper: any) {
    this.controlledSwiper = swiper;
  }

}
